<template>
    <div class="page-loading-indicator">
        <loader />
    </div>
</template>

<style lang="scss">
    @import url("styles.scss");
</style>